// import * as SelectPrimitive from "@radix-ui/react-select";
// import { FaChevronDown } from "react-icons/fa";
// import "../assets/css/product.css";

// export function CustomSelect({
//   options = [],
//   placeholder = "Select...",
//   onChange,
//   value,
//   icon,
//   showLabel,
//   labelName,
//   customClass,
// }) {
//   const selectedOption = options.find((option) => option.value === value);

//   return (
//     <>
//       {showLabel && labelName && (
//         <label className="custom-select-label">{labelName}</label>
//       )}
//       <SelectPrimitive.Root onValueChange={onChange} value={value || ""}>
//         <SelectPrimitive.Trigger
//           className={`custom-select-trigger ${customClass ? customClass : ""}`}
//         >
//           <SelectPrimitive.Value placeholder={placeholder}>
//             {selectedOption ? selectedOption.label : placeholder}
//           </SelectPrimitive.Value>
//           <SelectPrimitive.Icon>
//             {icon ? icon : <FaChevronDown />}
//           </SelectPrimitive.Icon>
//         </SelectPrimitive.Trigger>

//         <SelectPrimitive.Portal>
//           <SelectPrimitive.Content
//             className="custom-select-content"
//             position="popper"
//             sideOffset={5}
//             align="center"
//             avoidCollisions
//           >
//             <SelectPrimitive.Viewport
//               className={`${customClass ? customClass : ""}`}
//             >
//               {options.map((option, index) => (
//                 <SelectPrimitive.Item
//                   key={index}
//                   value={option.value}
//                   className="custom-select-item"
//                 >
//                   <SelectPrimitive.ItemText>
//                     {option.label}
//                   </SelectPrimitive.ItemText>
//                 </SelectPrimitive.Item>
//               ))}
//             </SelectPrimitive.Viewport>
//           </SelectPrimitive.Content>
//         </SelectPrimitive.Portal>
//       </SelectPrimitive.Root>
//     </>
//   );
// }




import * as SelectPrimitive from "@radix-ui/react-select";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { FaChevronDown } from "react-icons/fa";
import "../assets/css/product.css";

export function CustomSelect({
  options = [],
  placeholder = "Select...",
  placeholderKey = "Items",
  onChange,
  value,
  icon,
  showLabel,
  labelName,
  customClass,
  isMulti = false,
}) {
  const handleMultiChange = (val) => {
    if (Array.isArray(value)) {
      const alreadySelected = value.includes(val);
      if (alreadySelected) {
        onChange(value.filter((v) => v !== val));
      } else {
        onChange([...value, val]);
      }
    } else {
      onChange([val]);
    }
  };

  if (isMulti) {
    // ✅ Multi-select dropdown using DropdownMenu
    return (
      <>
        {showLabel && labelName && (
          <label className="custom-select-label">{labelName}</label>
        )}
        <DropdownMenu.Root>
          <DropdownMenu.Trigger
            className={`custom-select-trigger ${customClass || ""}`}
          >
            {value?.length > 0
              ? `${value.length} Selected ${placeholderKey}`
              : placeholder}
            {icon || <FaChevronDown style={{ marginLeft: 8 }} />}
          </DropdownMenu.Trigger>

          <DropdownMenu.Content
            className={`custom-select-content ${customClass || ""}`}
            sideOffset={5}
          >
            <div className="custom_multiselect_inner">
              {options.map((option) => (
                <DropdownMenu.CheckboxItem
                  key={option.value}
                  checked={value?.includes(option.value)}
                  onCheckedChange={() => handleMultiChange(option.value)}
                  className={`custom-select-item ${value?.includes(option.value) ? "selected" : ""
                    }`}
                  onSelect={(e) => e.preventDefault()}
                >
                  {option.label}
                </DropdownMenu.CheckboxItem>
              ))}
            </div>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </>
    );
  }

  // ✅ Single-select dropdown using SelectPrimitive
  return (
    <>
      {showLabel && labelName && (
        <label className="custom-select-label">{labelName}</label>
      )}
      <SelectPrimitive.Root onValueChange={onChange} value={value || ""}>
        <SelectPrimitive.Trigger
          className={`custom-select-trigger ${customClass || ""}`}
        >
          <SelectPrimitive.Value placeholder={placeholder} />
          <SelectPrimitive.Icon>
            {icon || <FaChevronDown />}
          </SelectPrimitive.Icon>
        </SelectPrimitive.Trigger>

        <SelectPrimitive.Portal>
          <SelectPrimitive.Content
            className="custom-select-content"
            position="popper"
            sideOffset={5}
            align="center"
            avoidCollisions
          >
            <SelectPrimitive.Viewport
              className={`${customClass || ""}`}
            >
              {options.map((option, index) => (
                <SelectPrimitive.Item
                  key={index}
                  value={option.value}
                  className="custom-select-item"
                >
                  <SelectPrimitive.ItemText>
                    {option.label}
                  </SelectPrimitive.ItemText>
                </SelectPrimitive.Item>
              ))}
            </SelectPrimitive.Viewport>
          </SelectPrimitive.Content>
        </SelectPrimitive.Portal>
      </SelectPrimitive.Root>
    </>
  );
}
